import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'
import { OpenItemsDialogViewModel } from './OpenItemsDialogViewModel'

interface Props {
  vm: OpenItemsDialogViewModel
}

export default observer(function OpenItemsDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_workspace-settings.svg')}
            />
          )}
          <ModalSheetContentTitle>
            Are you sure you want to report open items?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Reporting open items will notify the client that certain documents
            are missing. Please ensure you have prepared a list of missing items
            to provide to the client.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.close}
            disabled={vm.answerOpenItems.pending}
          >
            Cancel
          </Button>
          <Button
            submit
            loading={vm.answerOpenItems.pending}
            disabled={vm.answerOpenItems.pending}
            onClick={vm.answerOpenItems}
            type="primary"
            dataTest="job-progression-set-open-items-dialog-button"
          >
            Report Open Items
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
